import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Bulletin_Document, TableSchema } from '../../model/bulletin';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import * as t from '../../lib/select/select-service';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../../services/filter-data.service';
import { AppService } from '../../services/app.service';
import { ActionResultClass } from 'projects/Shared-Lib/model/search-result';

@Component({
  selector: 'app-bulletin-edit',
  templateUrl: './bulletin-edit.component.html',
  styleUrls: ['./bulletin-edit.component.css']
})
export class BulletinEditComponent implements OnInit {
  @ViewChild('myTab') myTab;
  PostData: Bulletin_Document;
  cardTitle = 'Bulletin Edit';
  controllerName = 'Bulletin';
  IsNew: boolean;
  EditData = new TableSchema();
  BulletinId: string;
  DropdownEnabled = t.GetItems(t.Items.Options_Enabled, false).slice(0);

  constructor(private dataSer: DataService,
    private dlgService: DialogService,
    private filterService: FilterDataService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private appService: AppService) {
    this.PostData = new Bulletin_Document();
  }


  ngOnInit() {
    this.BulletinId = this.actRoute.snapshot.paramMap.get('id');
    if (!this.BulletinId) {
      this.IsNew = true;
      this.cardTitle = 'Bulletin Create';
    } else {
      this.IsNew = false;
    }
    if (!this.IsNew) {
      this.dataSer.getData(this.controllerName + '/' + this.BulletinId, null,
        (data) => {
          this.PostData.SetData(data);
        });
    }
  }

  isValid(): boolean {
    if ((this.PostData.EffectiveDate && this.PostData.EffectiveDate !== '')
      && (this.PostData.ExpiredDate && this.PostData.ExpiredDate !== '')
      && (this.PostData.Subject && this.PostData.Subject !== '')
      && (this.PostData.Contents && this.PostData.Contents !== '')) {
      return false;
    }
    return true;
  }

  Submit() {
    let d: TableSchema = this.PostData;

    const submitOKCallBack = (res: ActionResultClass) => {
      let result: Promise<any>;
      if (!this.IsNew) {
        result = this.dlgService.EditSubmit();
      } else {
        result = this.dlgService.CreateSubmit();
      }

      result.then((ret) => {
        if (ret === 'Back') {
          this.router.navigate(['/Auth/Bulletin']);
        } else if (ret === 'Create Another') {
          this.PostData = new Bulletin_Document();
        }
      }).catch((error) => {
        console.error(error);
      });
    }

    if (!this.IsNew) {
      this.dataSer.updateData(this.controllerName + '/' + this.BulletinId, d, submitOKCallBack, null, (data) => { this.OnDataSrvEnd(); });
    } else {
      this.dataSer.addData(this.controllerName, d, submitOKCallBack, null, (data) => { this.OnDataSrvEnd(); });
    }

  }
  OnDataSrvEnd() {
    setTimeout(() => this.appService.SetLoadingState(false), 0);
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    console.log(lastPageInfo);
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
      console.log('RouteName', lastPageInfo.RouteName);
    }
    else
      this.router.navigate(['/Auth/Bulletin']);
  }
}
